/**
 * @generated SignedSource<<a15cd19c4eb175d06f665a3510cfe482>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type MigrateListConfigClickListener_JiraView$data = {
  readonly id: string;
  readonly savedViewId?: string | null | undefined;
  readonly " $fragmentType": "MigrateListConfigClickListener_JiraView";
};
export type MigrateListConfigClickListener_JiraView$key = {
  readonly " $data"?: MigrateListConfigClickListener_JiraView$data;
  readonly " $fragmentSpreads": FragmentRefs<"MigrateListConfigClickListener_JiraView">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "MigrateListConfigClickListener_JiraView",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "savedViewId"
        }
      ]
    }
  ],
  "type": "JiraIssueSearchViewMetadata",
  "abstractKey": "__isJiraIssueSearchViewMetadata"
};

(node as any).hash = "c00cd5f5556284e990fce30c0e39a138";

export default node;
